var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEdit = function SvgEdit(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M14.001 14a.75.75 0 1 1-.002 1.5l-12-.008a.75.75 0 0 1 .002-1.5zM10.116 1.08a2.054 2.054 0 0 1 2.86 0l.677.663.138.15a1.947 1.947 0 0 1-.138 2.647l-8.11 7.944H2V9.027zm-6.6 8.56V11h1.398l6.012-5.889-1.393-1.363zm8.387-7.511a.514.514 0 0 0-.715 0l-.583.57 1.393 1.362.583-.57a.49.49 0 0 0 0-.7z"
  })));
};
export default SvgEdit;